import { ArrowDropDown } from '@mui/icons-material';
import { Box } from '@mui/material';
import { FC } from 'react';

interface SingleSelectCellProps {
    value: string;
}

const SingleSelectCell: FC<SingleSelectCellProps> = ({ value }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 0.5,
                width: '100%',
                height: '100%',
            }}
        >
            <span style={{ display: 'flex', alignItems: 'center' }}>{value}</span>
            <ArrowDropDown sx={{ fontSize: 16, opacity: 0.6, display: 'flex', alignItems: 'center' }} />
        </Box>
    );
};

export default SingleSelectCell;
